import React from 'react';
import AboutSection from '../components/AboutSection';
import IntroParallaxSection from '../components/IntroParallaxSection'; // We'll use this here
import AboutSmartlight from '../components/AboutSmartlight';
import WhoWeAre from '../components/WhoWeAre';
import OurTeam from '../components/OurTeam';
import ProductShowcase from '../components/ProductShowcase';
import CatalogueDownloadSection from '../components/CatalogueDownloadSection';
import AllCataloguesSection from '../components/AllCataloguesSection';

export default function ProductPage() {
  return (
    <main>
      <CatalogueDownloadSection />
      <AllCataloguesSection />
      <ProductShowcase />
      
      {/* You could add more sections specific to the About page here */}
    </main>
  );
}